// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"OrderForwardingSummary_confirmButton__3qfKw"};